import { ReactElement } from 'react';

import { ActionTypes } from '../../models';
import { useProviderIframe } from './useProviderIframe';

import styles from './styles.module.scss';

export interface ProviderIframeProps {
  actionType: ActionTypes;
  src: string;
  width: number | null;
  height: number | null;
  defaultSize: number;
  ref: (frame: HTMLIFrameElement) => void;
  name: string;
}

export const ProviderIframe = ({
  actionType,
  src,
  width,
  height,
  defaultSize,
  ref,
  name,
}: ProviderIframeProps): ReactElement => {
  useProviderIframe({ actionType });

  return (
    <iframe
      data-test="provdier-iframe"
      className={styles.iframe}
      title="provider-iframe"
      src={src}
      name={name}
      width={width || defaultSize}
      height={height || defaultSize}
      ref={ref}
      allow="clipboard-write; payment"
    />
  );
};
